module.exports = __webpack_public_path__ + "img/icon-gen-addfaq.0e18f073.png";